import axios from "@/apis/axios-client";

const GetAccountInfo = async () => {
    return await axios.client
        .get("/api/accountinfo")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log("Get AccInfo:", error);
            return error;
        });
};

const AccountInfoApi = {
    GetAccountInfo: GetAccountInfo,
};

export default AccountInfoApi;